import { useMemo } from 'react';
import { useOpts } from '../../context';
import getAmountStringForAllocation from '../utils/get-amount-string-for-allocation';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import useAmountOrPercentageSupported from '../../views/AmountSelection/FullSwitchAndMore/hooks/useAmountOrPercentageSupported';
function useSwitchConfirmationAmountText() {
    var getLocalizedString = useGetLocalizedString();
    var amountOrPercentageSwitchSupported = useAmountOrPercentageSupported();
    var _a = useOpts(), loadedPlatform = _a.loadedPlatform, disableDirectDepositSplitting = _a.linkTokenPayload.disableDirectDepositSplitting, amountSelection = _a.amountSelection;
    var amountText = useMemo(function () {
        if (disableDirectDepositSplitting || !amountOrPercentageSwitchSupported) {
            if (loadedPlatform === null || loadedPlatform === void 0 ? void 0 : loadedPlatform.fullSwitchSupported) {
                return getLocalizedString('FULL_PAYCHECK');
            }
            return getLocalizedString('REMAINDER');
        }
        return getAmountStringForAllocation(amountSelection, getLocalizedString);
    }, [
        loadedPlatform,
        disableDirectDepositSplitting,
        amountSelection,
        getLocalizedString,
        amountOrPercentageSwitchSupported,
    ]);
    return amountText;
}
export default useSwitchConfirmationAmountText;
